import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ConsentMoreinfoPageComponent } from '../component/page/consent-moreinfo-page/consent-moreinfo-page.component';
import { IagPortalPageComponent } from '../component/page/iag-portal-page/iag-portal-page.component';

const routes: Routes = [
  { path: 'iagportal', component: IagPortalPageComponent },
  { path: 'GDPRregulations', component: ConsentMoreinfoPageComponent },
  { path: 'iagportal/:pageTitle', component: IagPortalPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppIagPortalRoutingModule {}
